const state = {
  fights: [],
  currentFight: [],
  currentKeys: [],
  keysCategoryId: null
}

export default state
